import { Dimensions, PixelRatio } from 'react-native';
// import CommonBridge from './CommonBridge';
import DimensionManager, { DEFAULT_WIDTH_DP_UI as _DEFAULT_WIDTH_DP_UI } from './DimensionManager';

// 屏幕大小比例
export const Current_Device_Width_DP = Dimensions.get('window').width;
export const Current_Device_Height_DP = Dimensions.get('window').height;
const dimensionManager = new DimensionManager(Current_Device_Width_DP, Current_Device_Height_DP);
export const PIXEL = 1 / PixelRatio.get();

// export const WIDTH_HEIGHT_RATIO = dimensionManager.getWidthHeightScale();
// UI给图比例大小
export const DEFAULT_WIDTH_DP_UI = _DEFAULT_WIDTH_DP_UI;

// function getWidthHeightScale () {
//   // let width = Dimensions.get('window').width;
//   // const height = Dimensions.get('window').height;
//   // if (CommonBridge.isWeb()) {
//   //   width = Math.min(Current_Device_Width_DP, 600);
//   // }
//   // return width / height;
//   return dimensionManager.getWidthHeightScale();
// }

/**
 * [scaledp 将dp进行等比例放大缩小]
 */

// WIDTH_HEIGHT_RATIO > 0.7 为了适配折叠屏  常理!CommonBridge.isWeb()就可以解决了
function Scaledp(dp, noRound = false, neesCancelPadScale) {
  // const scaledp = (CommonBridge.isTablet() || WIDTH_HEIGHT_RATIO > 0.7 || !CommonBridge.isWeb()) ? dp * Current_Device_Width_DP / DEFAULT_WIDTH_DP_UI
  // : dp * Math.min(Current_Device_Width_DP, 600) / DEFAULT_WIDTH_DP_UI;
  // if (noRound) {
  //   return scaledp;
  // }
  // return PixelRatio.roundToNearestPixel(scaledp);
  return dimensionManager.scaleDp(dp, noRound, neesCancelPadScale);
}
function ScaledpUnlimit(dp, noRound = false) {
  // const scaledp = dp * Dimensions.get('window').width / DEFAULT_WIDTH_DP_UI;
  // if (noRound) {
  //   return scaledp;
  // }
  // return PixelRatio.roundToNearestPixel(scaledp);
  return dimensionManager.scaleDpUnlimit(dp, noRound);
}
function ScaleFontSize(fontsize) {
  // if (CommonBridge.isAndroid()) {
  //   return Math.ceil(Scaledp(fontsize)) * Math.min(1, PixelRatio.getFontScale());
  // } else {
  //   return Math.ceil(Scaledp(fontsize));
  // }
  return dimensionManager.scaleFontSize(fontsize);
}

function ScaleLineHeight(lineheight) {
  // if (CommonBridge.isIOS()) {
  //   return Scaledp(lineheight);
  // }
  // const sclineheight = Scaledp(lineheight, true);
  // return Math.ceil(sclineheight + 3);
  return dimensionManager.scaleLineHeight(lineheight);
}

const Dimens = {
  fill_width: Dimensions.get('window').width,
  fill_height: Dimensions.get('window').height,
  dp1: Scaledp(1),
  dp2: Scaledp(2),
  dp3: Scaledp(3),
  dp4: Scaledp(4),
  dp5: Scaledp(5),
  dp6: Scaledp(6),
  dp7: Scaledp(7),
  dp8: Scaledp(8),
  dp10: Scaledp(10),
  dp11: Scaledp(11),
  dp12: Scaledp(12),
  dp14: Scaledp(14),
  dp15: Scaledp(15),
  dp16: Scaledp(16),
  dp17: Scaledp(17),
  dp18: Scaledp(18),
  dp19: Scaledp(19),
  dp20: Scaledp(20),
  dp22: Scaledp(22),
  dp25: Scaledp(25),
  dp40: Scaledp(40),
  dp44: Scaledp(44),
  dp63: Scaledp(63),
  dp90: Scaledp(90),
  font8: ScaleFontSize(8),
  font9: ScaleFontSize(9),
  font10: ScaleFontSize(10),
  font11: ScaleFontSize(11),
  font12: ScaleFontSize(12),
  font13: ScaleFontSize(13),
  font14: ScaleFontSize(14),
  font15: ScaleFontSize(15),
  font16: ScaleFontSize(16),
  font17: ScaleFontSize(17),
  font18: ScaleFontSize(18),
  font19: ScaleFontSize(19),
  font20: ScaleFontSize(20),
  font21: ScaleFontSize(21),
  font22: ScaleFontSize(22),
  font23: ScaleFontSize(23),
  font24: ScaleFontSize(24),
  font25: ScaleFontSize(25),
  font26: ScaleFontSize(26),
  font27: ScaleFontSize(27),
  font28: ScaleFontSize(28),
  font30: ScaleFontSize(30),
  font32: ScaleFontSize(32),
  font34: ScaleFontSize(34),
  font39: ScaleFontSize(39),
  fsTitle: ScaleFontSize(15),
  fsText: ScaleFontSize(13),
  fsGroup: ScaleFontSize(14),
  fsDesc: ScaleFontSize(13),
  fsTag: ScaleFontSize(10),
  fsButton: ScaleFontSize(14),
  fsBar: ScaleFontSize(16),
  fsBarText: ScaleFontSize(12),
  fsMenuTitle: ScaleFontSize(14),
  fsMenuText: ScaleFontSize(13),
};

function proxyGet(obj, prop) {
  try {
    const value = obj[prop];
    switch (Object.prototype.toString.call(value)) {
      case '[object Number]':
        switch (prop) {
          case 'fontSize':
            return ScaleFontSize(value);
          case 'lineHeight':
            return ScaleLineHeight(value);
          default:
            if (value <= 1 || ['elevation', 'zIndex'].includes(prop)) {
              // 特殊keyt不需要转换 如flex、shadowOpacity
              return value;
            }
            return Scaledp(value);
        }
      case '[object Object]':
        // return value;

        if (value.__scale === false) {
          return value;
        }
        return new Proxy(value, { get: proxyGet });
      default:
        return value;
    }
  } catch (e) {}
}

// 转化整个style
const ScaleStyle = (value = {}, key = '', unlimit = false) => {
  // try{
  //   return new Proxy(value, {get: proxyGet});
  // }catch(e) {
  // console.log('proxy err', value);
  //   return value;
  // }
  // switch (Object.prototype.toString.call(value)) {
  //   case '[object Number]':
  //     switch (key) {
  //     case 'fontSize':
  //       return ScaleFontSize(value);
  //     case 'lineHeight':
  //       return ScaleLineHeight(value);
  //     default:
  //       if (value <= 1 || ['elevation', 'zIndex'].includes(key)) { // 特殊keyt不需要转换 如flex、shadowOpacity
  //         return value;
  //       }
  //       return unlimit ? ScaledpUnlimit(value) : Scaledp(value);
  //     }
  //   case '[object Object]':
  //     if (value.__scale === false) {
  //       return value.__value;
  //     }
  //     return Object.keys(value).reduce((prevObj, currKey) => {
  //       return {
  //         ...prevObj,
  //         [currKey]: ScaleStyle(value[currKey], currKey, unlimit),
  //       };
  //     }, {});
  //   default:
  //     return value;
  //   }
  return dimensionManager.scaleStyle(value, key, unlimit);
};

/**
 * 支持属性值关闭自己的缩放
 * ScaleStyle({
 *    wrapper: {
 *        width: 100,
 *        height: noScale(100)
 *    }
 * })
 */
function noScale(value) {
  // return {
  //   __scale: false,
  //   __value: value,
  // };
  return dimensionManager.noScale(value);
}

function noPadScale(value) {
  // return {
  //   __scale: false,
  //   __value: value,
  // };
  return dimensionManager.noPadScale(value);
}

function setScaleDp(width, height, scale = 1) {
  return dimensionManager.setScaleDp(width, height, scale);
}

export { Dimens, Scaledp, ScaleFontSize, ScaleLineHeight, ScaleStyle, noScale, setScaleDp, noPadScale };
